import request from '@/utils/request'

// 消息列表（滚屏消息、活动公告、系统）
export function combinedListApi(params) {
  return request.get('/siteMessage/combinedList', { params })
}

// 公告列表
export function bulletinListApi() {
  return request.get('/kfManage/bulletinList')
}

// 客服列表
export function configListApi() {
  return request.get('/kfManage/configList')
}

// 官方频道
export function officialChannelListApi(paramsData) {
  return request.get('/kfManage/officialChannelList', { params: paramsData })
}

// 滚屏消息
export function scrollMsgListApi() {
  return request.get('/kfManage/scrollMsgList')
}

// 消息列表
export function siteMessageListApi(data) {
  return request.post('/v1/siteMessage/list', data)
}

// 滚屏消息
export function sendMessageApi() {
  return request.get('/testBonus/testSendMessage')
}
